import { zipSync } from 'fflate';

function segment(value, fallback) {
  return Array.from(String(value || '').trim().normalize('NFD'))
    .filter(character => character.charCodeAt(0) >= 32).join('')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[<>:"/\\|?*]+/g, '')
    .replace(/\s+/g, '_')
    .replace(/[^a-zA-Z0-9._-]+/g, '_')
    .replace(/^_+|_+$/g, '').replace(/\.+$/g, '') || fallback;
}

// PDFs are already generated locally; no upload is needed to package them.
export function createAttendanceArchive() {
  const files = Object.create(null);
  let count = 0;
  return {
    get count() { return count; },
    async add(pdf, metadata) {
      const folder = [segment(metadata.comuna, 'Sin_comuna'),
        segment(metadata.activity, 'Sin_actividad'), segment(metadata.group, 'Sin_grupo')].join('/');
      let name = segment(metadata.fileName, 'asistencia.pdf');
      if (!name.toLowerCase().endsWith('.pdf')) name += '.pdf';
      let path = `${folder}/${name}`;
      let suffix = 2;
      while (files[path]) {
        path = `${folder}/${name.replace(/\.pdf$/i, `_${suffix++}.pdf`)}`;
      }
      files[path] = new Uint8Array(await pdf.arrayBuffer());
      count += 1;
    },
    toBlob() {
      return new Blob([zipSync(files, {level: 0})], {type: 'application/zip'});
    }
  };
}
